module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticStyle: {
      "z-index": "99",
      "position": "fixed",
      "top": "0"
    },
    attrs: {
      "light": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backLink),
      expression: "backLink"
    }],
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconVisibility || _vm.editModePossible),
      expression: "iconVisibility || editModePossible"
    }],
    attrs: {
      "disabled": _vm.disabledState,
      "icon": ""
    },
    on: {
      "click": _vm.buttonClicked
    }
  }, [(_vm.iconVisibility) ? _c('v-icon', {
    staticClass: "cart",
    class: {
      'shopping': this.$store.getters.getShoppingState
    }
  }, [_vm._v("shopping_cart")]) : _vm._e(), _vm._v(" "), (_vm.editModePossible) ? _c('v-icon', [_vm._v(_vm._s(_vm.editMode))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356c25e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/MainHeader.vue
// module id = 485
// module chunks = 1